import { InputNumber, Segmented } from 'antd'
import type { z } from 'zod'
import type { billSchema } from '@super-mega/server/contracts/bill'
import { formatAmount, formatAmountInput } from '@/utils/money.ts'
import { BILL_KINDS } from './const/bill-search.ts'
import { issueEntryAmount, type BillIssueEntry } from './utils/bill-issue.ts'

export function BillUtilityFields({
  bill,
  entry,
  onChange,
  disabled
}: {
  bill: z.infer<typeof billSchema>
  entry: BillIssueEntry
  onChange: (entry: BillIssueEntry) => void
  disabled: boolean
}) {
  const unit = bill.feeType === 'water' ? '吨' : '度'
  return (
    <div className="flex flex-col gap-2" role="group" aria-label={`账单 ${bill.id} 计费方式与用量`}>
      <Segmented<BillIssueEntry['mode']>
        size="small"
        value={entry.mode}
        disabled={disabled}
        options={[
          { value: 'usage', label: '按用量计算' },
          { value: 'manual', label: '直接填金额' }
        ]}
        onChange={(mode) => onChange({ ...entry, mode, amount: entry.amount ?? issueEntryAmount(bill, entry) })}
      />
      {entry.mode === 'usage' ? (
        <div className="flex items-center gap-1.5 whitespace-nowrap">
          <InputNumber<string>
            aria-label={`账单 ${bill.id} ${BILL_KINDS[bill.feeType]}用量`}
            stringMode
            min="0"
            max="99999999999999.9999"
            precision={4}
            controls={false}
            className="w-24!"
            placeholder="本期用量"
            suffix={unit}
            value={entry.quantity}
            disabled={disabled}
            onChange={(quantity) => onChange({ ...entry, quantity })}
          />
          <span className="text-content-soft">×</span>
          <InputNumber<string>
            aria-label={`账单 ${bill.id} ${BILL_KINDS[bill.feeType]}单价`}
            stringMode
            min="0"
            max="9999999999999999.99"
            precision={2}
            formatter={formatAmountInput}
            controls={false}
            className="w-32!"
            placeholder="单价"
            suffix={`元/${unit}`}
            value={entry.unitPrice}
            disabled={disabled}
            onChange={(unitPrice) => onChange({ ...entry, unitPrice })}
          />
        </div>
      ) : bill.meteredUnitPrice == null ? (
        <span className="text-content-soft text-xs">可直接填金额，或切换后填写用量与单价</span>
      ) : (
        <span className="text-content-soft text-xs">
          约定单价：{formatAmount(bill.meteredUnitPrice)} 元/{unit}
        </span>
      )}
    </div>
  )
}
